import { render } from "./ChatComp.vue?vue&type=template&id=629ebc90&scoped=true"
import script from "./ChatComp.vue?vue&type=script&lang=js"
export * from "./ChatComp.vue?vue&type=script&lang=js"

import "./ChatComp.vue?vue&type=style&index=0&id=629ebc90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629ebc90"]])

export default __exports__